<script lang="ts">
  import {onMount} from 'svelte'
  import type {Tag} from '../types'
  import api from '../api/api'
  import {changeLocale, lang, locales, t} from '../i18n'
  import {modal} from '../stores/modal'
  import ContactUs from '../ContactUs.svelte'
  import {user} from '../stores/user'
  import {Link} from 'svelte5-router'
  import Dropdown from './Dropdown.svelte'
  import {flash} from '../stores/flash'
  import ValidationMessage from './ValidationMessage.svelte'

  let subscription = {email: ''}
  let tags: Tag[] = []
  let error: string = ''

  onMount(() => {
    fetchTags()
  })

  async function fetchTags() {
    tags = await api.get<Tag[]>('/tags/popular?per=9')
  }

  function tagUrl(tag: { name: string }) {
    const params = new URLSearchParams({tags: [tag.name].toString()})
    return `/explore?${params.toString()}`
  }

  function subscribe(e: Event) {
    e.preventDefault()

    error = ''

    api.post('/daily_poem_subscriptions', {subscription}).then(() => {
      subscription.email = ''
      flash.show(t.footer.subscribe.success)
    }).catch(response => error = response.errors.email || t.footer.subscribe.error)
  }

  function openContactUs(e: Event) {
    e.preventDefault()
    modal.show(ContactUs)
  }

  function onChangeLocale(code: any) {
    changeLocale(code as string)
  }
</script>

<footer class="clearfix">
  <div class="grid three">
    <div class="grid__item">
      <h3>{t.footer.title}</h3>
      <ul class="footer-menu">
        <li>
          <Link to="/about">{t.footer.about_us}</Link>
        </li>
        <li>
          <Link to="/help">{t.footer.help}</Link>
        </li>
        <li>
          <Link to="/privacy-policy">{t.footer['privacy-policy']}</Link>
        </li>
        <li>
          <a class="contact_us" onclick={openContactUs}>
            {t.footer.contact_us}
          </a>
        </li>
        {#if $user}
          <li>
            <Dropdown options={locales.map(l => ({value: l.code, label: t.locales[l.code]}))}
                      onChange={onChangeLocale} value={lang}>
              <svelte:fragment slot="prefix">
                <span>{t.footer.language}</span>
              </svelte:fragment>
            </Dropdown>
          </li>
        {/if}
      </ul>

      <div class="social-links">
        <a href="https://www.facebook.com/ilovepoetree" class="icon-p-facebook" />
        <a href="https://www.instagram.com/ilovepoetree" class="icon-p-inst" />
        <a href="https://twitter.com/ilovepoetree" class="icon-p-twitter" />
        <a href="https://plus.google.com/u/0/112980321976771730703" class="icon-p-google" />
      </div>
    </div>

    <div class="grid__item">
      <h3>{t.footer.subscribe.title}</h3>
      <form onsubmit={subscribe} class="subscribe-form">
        <div class="line">
          <input type="email" placeholder="example@gmail.com" bind:value={subscription.email} required/>
          <ValidationMessage errors={[error]}/>
        </div>

        <button type="submit" class="subscribe-btn">{t.footer.subscribe.button}</button>
      </form>

      <div class="copyright">{t.footer.rights}</div>
    </div>

    <div class="grid__item">
      <h3>{t.footer.tags}</h3>
      {#if tags.length > 0}
        <div class="tags-columns">
          <ul>
            {#each tags.slice(0, 5) as tag}
              <li>
                <Link to={tagUrl(tag)} class="italic">
                  {tag.name} ({tag.poems_count})
                </Link>
              </li>
            {/each}
          </ul>
          <ul>
            {#each tags.slice(5) as tag}
              <li><a href={tagUrl(tag)} class="italic">{tag.name} ({tag.poems_count})</a></li>
            {/each}
            <li>
              <Link to="/tags">{t.footer.all_tags}</Link>
            </li>
          </ul>
        </div>
      {/if}
    </div>
  </div>
</footer>
